import { render, staticRenderFns } from "./PhotoUploadBox.vue?vue&type=template&id=ba5061b4&"
import script from "./PhotoUploadBox.vue?vue&type=script&lang=js&"
export * from "./PhotoUploadBox.vue?vue&type=script&lang=js&"
import style0 from "./PhotoUploadBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports